import { combineReducers } from 'redux';
import { slice as auth } from '../../pages/SignInPage/_BLL/slice';
import { slice as notifications } from '../../pages/app/_BLL/notifications/slice';
import { slice as metaDictionaries } from '../../pages/app/_BLL/metaDictionaries/slice';
import { slice as userInfo } from 'src/pages/MainPage/_BLL/slice';
import { slice as company } from 'src/pages/CompanyPage/_BLL/slice';
import { slice as report } from 'src/pages/ReportPage/api/database/slice';
import { slice as recommendations } from 'src/widgets/AIInsightsMC/_BLL/slice';

export const rootReducer = combineReducers({
	auth: auth.reducer,
	notifications: notifications.reducer,
	metaDictionaries: metaDictionaries.reducer,
	report: report.reducer,
	userInfo: userInfo.reducer,
	company: company.reducer,
	recommendations: recommendations.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
